import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/**
 * Enter-only fade for each route. Keyed on the pathname in MainLayout, so React
 * remounts it on navigation and re-runs this enter animation. There is
 * deliberately NO exit animation and NO `AnimatePresence mode="wait"`: that
 * pattern makes every navigation wait for the old page to fade out first,
 * leaving a blank beat before anything new shows. Fading the new page straight
 * in makes navigation feel instant. Reduced-motion users get no movement.
 */
export const PageTransition: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      initial={{ opacity: 0, y: reduce ? 0 : 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: reduce ? 0 : 0.22, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
};
